import { render, staticRenderFns } from "./RiskAnalysisThreats.vue?vue&type=template&id=d33d3784&"
import script from "./RiskAnalysisThreats.vue?vue&type=script&lang=js&"
export * from "./RiskAnalysisThreats.vue?vue&type=script&lang=js&"
import style0 from "./RiskAnalysisThreats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports